import { BackendService } from './backend.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
/**
 * User service
 */
var UserService = (function () {
    /**
     * Constructor
     * @param {BackendService} backendService
     */
    function UserService(backendService) {
        this.backendService = backendService;
        this.currentUser = new BehaviorSubject(null);
        this.currentUser.next(JSON.parse(localStorage.getItem('user')));
    }
    /**
     * Stores a User object as the current user to be used and displayed around the app
     * @param {User} user The User object to store
     */
    UserService.prototype.setCurrentUser = function (user) {
        this.currentUser.next(user);
        this._user = user;
        localStorage.setItem('user', JSON.stringify(user));
    };
    /**
     * Creates new user
     * @param {string} prename Prename
     * @param {string} surname Surname
     * @param {string} email Email
     * @param {string} password Password
     * @returns {Promise<any>} Response as Promise
     */
    UserService.prototype.createUser = function (prename, surname, email, password) {
        return this.backendService.post('user', {
            prename: prename,
            surname: surname,
            email: email,
            password: password,
        });
    };
    /**
     * Updates user object
     * @param firstName
     * @param lastName
     * @param gender
     * @param language
     * @param timeZone
     * @param alias
     */
    UserService.prototype.updateUser = function (user) {
        return this.backendService.put('user/me', user);
    };
    /**
     * Activates user
     * @param {number} userId User ID
     * @param {string} token Activate-Token
     * @returns {Promise<any>} Response as Promise
     */
    UserService.prototype.activateUser = function (userId, token) {
        return this.backendService.post('user/' + userId + '/activate/' + token);
    };
    UserService.prototype.getThisUser = function () {
        var _this = this;
        return this.backendService.get('user/me').then(function (result) {
            _this.setCurrentUser(result);
        });
    };
    /**
     * Sends a request to reset password
     * @param {string} email Email
     * @returns {Promise<any>} Response as Promise
     */
    UserService.prototype.requestPasswordReset = function (email) {
        return this.backendService.post('auth/forgotpass', {
            email: email,
        });
    };
    /**
     * Sends new password after reset request
     * @param email Email
     * @param password Password
     * @param token Redeem password reset token
     * @returns {Promise<any>} Response as Promise
     */
    UserService.prototype.redeemPasswordReset = function (password, token) {
        return this.backendService.post('auth/forgotpass/new/' + token, {
            password: password,
        });
    };
    /**
     * Set a new Password for this user
     * @param oldPassword
     * @param newPassword
     */
    UserService.prototype.setPassword = function (oldPassword, newPassword) {
        return this.backendService.post('auth/changepass', {
            oldPassword: oldPassword,
            newPassword: newPassword,
        });
    };
    /**
     * Reactivate inactive user
     * @param token
     */
    UserService.prototype.reactivateUser = function (token) {
        return this.backendService.get("user/inactivity/" + token + "/reactivate");
    };
    /**
     * Delete inactive user
     * @param token
     */
    UserService.prototype.deleteUser = function (token) {
        return this.backendService.get("user/inactivity/" + token + "/delete");
    };
    UserService.prototype.getCompany = function () {
        return this.backendService.get("companies/");
    };
    return UserService;
}());
export { UserService };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/shared/services/user.service.ts.pre-build-optimizer.js